import { SerializedStyles, css } from '@emotion/react'
import React, { MouseEventHandler } from 'react'
import { Loading } from '../organisms/loading'
import { CUSTOM_BUTTON, CUSTOM_ICON } from '../template/custom-design-style'

interface ButtonProps {
  text: string
  onClick?: MouseEventHandler<HTMLDivElement>
  type?: 'submit' | 'button'
  buttonCss?: SerializedStyles | SerializedStyles[]
  className?: string
  disabled?: boolean
  loading?: boolean
  icon?: JSX.Element
}

export const Button: React.FC<ButtonProps> = ({
  disabled = false,
  type = 'button',
  text,
  buttonCss,
  onClick,
  loading = false,
  className,
  icon,
}) => {
  return (
    <div className={className ?? ''} css={[buttonWrapStyle, buttonCss]} onClick={onClick}>
      <button className={CUSTOM_BUTTON} type={type} disabled={disabled}>
        <div className={`${CUSTOM_ICON}-secondary`}>{icon}</div>
        <Loading size={32} loading={loading}>
          {text}
        </Loading>
      </button>
    </div>
  )
}

export const BorderButton: React.FC<ButtonProps> = ({
  disabled = false,
  type = 'button',
  text,
  buttonCss,
  onClick,
  loading = false,
  icon,
}) => {
  return (
    <div css={[buttonWrapStyle, buttonCss]} onClick={onClick}>
      <button className={`${CUSTOM_BUTTON}-secondary`} type={type} disabled={disabled}>
        {icon}
        <Loading size={32} loading={loading}>
          {text}
        </Loading>
      </button>
    </div>
  )
}

const buttonWrapStyle = css({
  width: '100%',
  textAlign: 'center',
  '> button': {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    height: '44px',
    cursor: 'pointer',
    '&:disabled': {
      opacity: 0.3,
    },
    position: 'relative',
    svg: {
      position: 'absolute',
      left: '1rem',
      top: 0,
      bottom: 0,
      margin: 'auto',
    },
  },
})
